import { Box, Paper, Tab, Tabs } from "@material-ui/core";
import { TabContext, TabPanel } from "@material-ui/lab";
import { ChangeEvent, useState } from "react";
import { useParams } from "react-router-dom";
import { HttpClient } from "../../../web-services/http-client";
import { ChartBlock } from "../../common/chart-block";
import { ExportBlock } from "../../common/export-block";
import { ParkingLotTitle } from "../../common/parking-lot-title";
import { TableBlock } from "../../common/table-block";
import "./parking-lot-page.scss";

// eslint-disable-next-line @typescript-eslint/naming-convention
export function ParkingLotPage(props: { httpClient: HttpClient })
{
    const [selectedStartDate, setSelectedStartDate] = useState(new Date((new Date().getTime() - (7 * 24 * 60 * 60 * 1000))));
    const [selectedTimeBreakdown, setSelectedTimeBreakdown] = useState<"ora" | "nap" | "nincs" | undefined>("nincs");
    const [selectedFormat, setSelectedFormat] = useState<"csv" | "xlsx" | undefined>("csv");
    const [selectedEndDate, setSelectedEndDate] = useState(new Date());
    const [selectedStartTime, setSelectedStartTime] = useState<Date | undefined>();
    const [selectedEndTime, setSelectedEndTime] = useState<Date | undefined>();
    const [selectedTab, setSelectedTab] = useState("tablazat");

    const { id, name } = useParams();
    const parkingLotId = id !== undefined ? parseInt(id, 10) : 0;
    return (
        <div className="scrollable-container">
            <TabContext value={selectedTab}>
                <div className="title-and-tab-container">
                    <ParkingLotTitle title={name ? name : ""} />
                    <Box className="tab-menu-box" sx={{ borderBottom: 1, borderColor: "divider" }}>
                        <Tabs
                            value={selectedTab}
                            onChange={(event: ChangeEvent<{}>, value: any) => setSelectedTab(value)}
                            indicatorColor="primary"
                            textColor="primary"
                        >
                            <Tab label="Táblázat" value="tablazat" />
                            <Tab label="Grafikon" value="grafikon" />
                            <Tab label="Exportálás" value="exportalas" />
                        </Tabs>
                    </Box>
                </div>

                <TabPanel className="tab-menu" value="tablazat">
                    <Paper className="main-paper">
                        <TableBlock
                            httpClient={props.httpClient}
                            parkingLotId= {parkingLotId}
                            selectedStartDate={selectedStartDate}
                            selectedStartTime={selectedStartTime}
                            selectedEndDate={selectedEndDate}
                            selectedEndTime={selectedEndTime}
                            handleStartDateChange={(date: any) => setSelectedStartDate(date)}
                            handleEndDateChange={(date: any) => setSelectedEndDate(date)}
                            handleStartTimeChange={(date: any) => setSelectedStartTime(date)}
                            handleEndTimeChange={(date: any) => setSelectedEndTime(date)}
                        />
                    </Paper>
                </TabPanel>
                <TabPanel className="tab-menu" value="grafikon" >
                    <Paper className="main-paper">
                        <ChartBlock
                            httpClient={props.httpClient}
                            parkingLotId= {parkingLotId}
                            selectedStartDate={selectedStartDate}
                            selectedStartTime={selectedStartTime}
                            selectedEndDate={selectedEndDate}
                            selectedEndTime={selectedEndTime}
                            selectedTimeBreakdown={selectedTimeBreakdown}
                            onTimeBreakdownChange={(val: "ora" | "nap" | "nincs" | undefined) => setSelectedTimeBreakdown(val)}
                            handleStartDateChange={(date: any) => setSelectedStartDate(date)}
                            handleEndDateChange={(date: any) => setSelectedEndDate(date)}
                            handleStartTimeChange={(date: any) => setSelectedStartTime(date)}
                            handleEndTimeChange={(date: any) => setSelectedEndTime(date)}
                        />
                    </Paper>
                </TabPanel>
                <TabPanel className="tab-menu" value="exportalas">
                    <Paper className="main-paper">
                        <ExportBlock
                            httpClient={props.httpClient}
                            parkingLotId= {parkingLotId}
                            selectedStartDate={selectedStartDate}
                            selectedStartTime={selectedStartTime}
                            selectedEndDate={selectedEndDate}
                            selectedEndTime={selectedEndTime}
                            selectedFormat={selectedFormat}
                            handleFormatChange={(val: "csv" | "xlsx" | undefined) => setSelectedFormat(val)}
                            handleStartDateChange={(date: any) => setSelectedStartDate(date)}
                            handleEndDateChange={(date: any) => setSelectedEndDate(date)}
                            handleStartTimeChange={(date: any) => setSelectedStartTime(date)}
                            handleEndTimeChange={(date: any) => setSelectedEndTime(date)}
                        />
                    </Paper>
                </TabPanel>
            </TabContext>
        </div>
    );
}
